import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router";
import RefreshIcon from "@mui/icons-material/Refresh";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import VideocamIcon from "@mui/icons-material/Videocam";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import classes from "./Widget.module.css";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";
import { StatusCode } from "../../utils";
import AUTH_CONTEXT from "../../store";
import { BASE_PATH_TO_ALL_USERS } from "../../base_routes_paths/data_paths";
import ARENO_API_ENDPOINT from "../../api";

const Widget = ({ type }) => {
  const navigate = useNavigate();
  const { token } = AUTH_CONTEXT();
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [count, setCount] = useState(0);
  const hasLoadedRef = useRef(false);
  const cacheKey = `widget_${type}_data`;

  const FetchUserCountApi = async () => {
    try {
      let response = await fetch(`${ARENO_API_ENDPOINT}/auth/AdminGetAllUserCount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        toast.error("Authentication Failed, please login again!", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      StatusCode(response, navigate);
      const responseData = await response.json();

      if (responseData.status === 207) {
        toast.error(responseData.error, {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      if (responseData.status === 200 && responseData.data) {
        setIsDataFetched(true);
        return responseData.data.userCount;
      }

      return null;
    } catch (e) {
      setIsDataFetched(false);
      toast.error(e.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return null;
    }
  };

  const FetchVideoSessionApi = async () => {
    try {
      let response = await fetch(`${ARENO_API_ENDPOINT}/conference/AdminGetAllVideoSessionData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        toast.error("Authentication Failed, please login again!", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      StatusCode(response, navigate);
      const responseData = await response.json();

      if (responseData.status === 207) {
        toast.error(responseData.error, {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      if (responseData.status === 200 && responseData.data) {
        setIsDataFetched(true);
        return responseData.data.totalCompeltedVideoSessions;
      }

      return null;
    } catch (e) {
      setIsDataFetched(false);
      toast.error(e.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return null;
    }
  };

  const FetchPhysioPlanApi = async () => {
    try {
      let response = await fetch(`${ARENO_API_ENDPOINT}/challenges/AdminGetAllPhysioPlanData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        toast.error("Authentication Failed, please login again!", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      StatusCode(response, navigate);
      const responseData = await response.json();

      if (responseData.status === 207) {
        toast.error(responseData.error, {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      if (responseData.status === 200 && responseData.data) {
        setIsDataFetched(true);
        return responseData.data.allPhysioPlanDataCount;
      }

      return null;
    } catch (e) {
      setIsDataFetched(false);
      toast.error(e.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return null;
    }
  };

  const FetchFitnessPlanApi = async () => {
    try {
      let response = await fetch(`${ARENO_API_ENDPOINT}/challenges/AdminGetAllFitnessPlanData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        toast.error("Authentication Failed, please login again!", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      StatusCode(response, navigate);
      const responseData = await response.json();

      if (responseData.status === 207) {
        toast.error(responseData.error, {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
        return null;
      }

      if (responseData.status === 200 && responseData.data) {
        setIsDataFetched(true);
        return responseData.data.allFitnessPlanDataCount;
      }

      return null;
    } catch (e) {
      setIsDataFetched(false);
      toast.error(e.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return null;
    }
  };

  const fetchData = async (isManualRefresh = false) => {
    // Check cache first (unless it's a manual refresh)
    // Always check cache on normal navigation, even if hasLoadedRef is false (component remounted)
    if (!isManualRefresh) {
      const cachedData = sessionStorage.getItem(cacheKey);
      if (cachedData) {
        try {
          const parsedData = JSON.parse(cachedData);
          setCount(parsedData.count);
          setIsDataFetched(true);
          hasLoadedRef.current = true;
          return; // Use cached data, don't fetch
        } catch (e) {
          console.error("Error parsing cached data:", e);
        }
      }
    }

    // Clear cache on manual refresh
    if (isManualRefresh) {
      sessionStorage.removeItem(cacheKey);
    }

    setIsLoading(true);
    setIsDataFetched(false);
    let result = null;
    let successMessage = "";

    if (type === "user") {
      result = await FetchUserCountApi();
      successMessage = "User count fetched successfully!";
    } else if (type === "video-session") {
      result = await FetchVideoSessionApi();
      successMessage = "Video session count fetched successfully!";
    } else if (type === "physio-plan") {
      result = await FetchPhysioPlanApi();
      successMessage = "Physio plan count fetched successfully!";
    } else if (type === "fitness-plan") {
      result = await FetchFitnessPlanApi();
      successMessage = "Fitness plan count fetched successfully!";
    }

    if (result !== null && result !== undefined) {
      setCount(result);
      // Cache the data in sessionStorage
      sessionStorage.setItem(cacheKey, JSON.stringify({ count: result }));
      hasLoadedRef.current = true;

      // Only show success toast on manual refresh
      if (isManualRefresh) {
        toast.success(successMessage, {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
    setIsLoading(false);
  };

  // Fetch data on component mount (no toast on initial load)
  useEffect(() => {
    // Check if this is a page reload (not just navigation)
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const isPageReload = navigationEntry?.type === 'reload';

    // If page was reloaded, clear cache and fetch fresh data
    if (isPageReload) {
      sessionStorage.removeItem(cacheKey);
      hasLoadedRef.current = false;
    }

    // Always check cache first (fetchData will handle cache check)
    fetchData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let data;

  switch (type) {
    case "user":
      data = {
        title: "USERS",
        link: "See all users",
        linkPath: BASE_PATH_TO_ALL_USERS,
        icon: (
          <PersonOutlinedIcon
            className={classes.icon}
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "video-session":
      data = {
        title: "VIDEO SESSIONS",
        link: "Video Sessions",
        linkPath: "/physio/video-sessions",
        icon: (
          <VideocamIcon
            className={classes.icon}
            style={{
              color: "#412A7B",
              backgroundColor: "rgba(65, 42, 123, 0.2)",
            }}
          />
        ),
      };
      break;
    case "physio-plan":
      data = {
        title: "PHYSIO PLANS",
        link: "Physio Plans",
        linkPath: "#",
        icon: (
          <LocalHospitalIcon
            className={classes.icon}
            style={{
              color: "#10b981",
              backgroundColor: "rgba(16, 185, 129, 0.2)",
            }}
          />
        ),
      };
      break;
    case "fitness-plan":
      data = {
        title: "FITNESS PLANS",
        link: "Fitness Plans",
        linkPath: "#",
        icon: (
          <FitnessCenterIcon
            className={classes.icon}
            style={{
              color: "#FCB401",
              backgroundColor: "rgba(252, 180, 1, 0.2)",
            }}
          />
        ),
      };
      break;
    default:
      data = {
        title: "",
        link: "",
        linkPath: "#",
        icon: null,
      };
      break;
  }

  return (
    <div className={classes.widget}>
      <div className={classes.left}>
        <span className={classes.title}>{data.title}</span>
        <span className={classes.counter}>
          {!isDataFetched ? (
            isLoading ? (
              <Box sx={{ display: "flex", margin: "10px 0px" }}>
                <CircularProgress size={20} />
              </Box>
            ) : (
              <button className={`${classes.button}`} onClick={() => fetchData(true)}>
                Fetch {data.title}
              </button>
            )
          ) : (
            count
          )}
        </span>
        <Link to={data.linkPath}>
          <span className={classes.link}>{data.link}</span>
        </Link>
      </div>
      <div className={classes.right}>
        <div
          className={classes.percentage_positive}
          onClick={() => fetchData(true)}
          style={{
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.6 : 1,
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          <RefreshIcon
            sx={{
              fontSize: '18px',
              animation: isLoading ? 'spin 1s linear infinite' : 'none',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              }
            }}
          />
        </div>
        {data.icon}
      </div>
    </div>
  );
};

export default Widget;
